import {TriangleDownIcon} from '@chakra-ui/icons';
import {Select, StyleProps, Tooltip} from '@chakra-ui/react';
import {UniteQuantite} from 'api-types/ffconnect';
import {SelectUniteIc, useGetSelectUniteOptions} from 'ff-common';
import {useTranslation} from 'react-i18next';
import {useSidePanelPanier} from '@/components/SidePanelPanier/SidePanelPanierContext';

export interface SelectUniteProps {
  ic: SelectUniteIc;
  /**
   * Dans le panier, on peut vouloir partir de l'unité qui avait mise sur la ligne de panier.
   */
  value: UniteQuantite | undefined;
  quantite_max?: number | undefined;
  onSelect?: (unite: UniteQuantite) => void;
}

export const SelectUnite: React.FC<StyleProps & SelectUniteProps> = ({
  ic,
  value,
  quantite_max,
  onSelect,
  ...props
}) => {
  const {t} = useTranslation();
  const {isOpen: isSidePanelOpen} = useSidePanelPanier();

  const {optionsList, isDisabled, commandableEnColis} =
    useGetSelectUniteOptions({ic, quantite_max, t});

  // utilisation direct de value mise à jour si préférences client sont présentes
  const unite = value ?? (commandableEnColis ? 'colis' : 'unitaire');

  // Texte affiché en tooltip au survol : libellé complet de l'option sélectionnée
  // (utile quand le select est rétréci et que le texte est tronqué côté
  // side panel panier ouvert — sinon le libellé tient en entier, pas de tooltip)
  const selectedTexte = optionsList.find((opt) => opt.value === unite)?.texte;

  // TODO TODO: gérer la préférence client, quand on arrive et qu'on a rien de défini !?

  return (
    <Tooltip
      label={selectedTexte}
      openDelay={400}
      borderRadius='8px'
      isDisabled={!isSidePanelOpen}
    >
      <Select
        bg='gray.lighter'
        border='none'
        color='gray.dark'
        icon={!isDisabled ? <TriangleDownIcon color='gray.dark' /> : undefined}
        iconColor='gray.dark'
        iconSize='xs'
        w={{base: 'inherit', md: '100%'}}
        height='35px'
        minW={{base: 'inherit', md: '200px'}}
        fontSize='xs'
        fontWeight={{base: '500', md: 'normal'}}
        _disabled={{opacity: 1}}
        value={unite}
        onChange={(event) => {
          event.preventDefault();
          onSelect?.(event.target.value as UniteQuantite);
        }}
        isDisabled={isDisabled}
        {...props}
      >
        {optionsList.map((opt) => {
          return (
            <option
              key={opt.value}
              value={opt.value}
            >
              {opt.texte}
            </option>
          );
        })}
      </Select>
    </Tooltip>
  );
};
